import { useZoneContext } from 'context/ZoneContext';
import { useContext, useEffect } from 'react';
import { ReactZoomPanPinchRef, TransformWrapper } from 'react-zoom-pan-pinch';
import { getMapInitialScale, mapScales } from '../../constants';
import { Zone } from '.';
import { MapTourContext } from 'context/MapTourContext';
import { getMovementDirection } from 'utils/utils';
import { useSideNavContext } from 'context';
import { Direction } from 'types';
import Drawer from './components/Drawer';
import { Container, MapContainer } from './Zone.styled';
import MapHeader from '../MapRenderer/MapHeader';
import LinkNotFound from '../LinkNotFound';
import { useMapParams } from 'hooks/useMapParams';
import { useCustomNavigate } from 'hooks/useCustomNavigate';
import { useLocation } from 'react-router-dom';

export const ZoneMap = () => {
    const { isMapTour } = useContext(MapTourContext);
    const { setShowMobileMenu } = useSideNavContext();
    const { zone, setScale, setPosition, mapState, position, selectedStation, expandedStation } = useZoneContext();
    const { MAX_SCALE, MIN_SCALE } = mapScales;
    const { position: initialPosition, scale: initialScale, station, toMapQueryString, subZone } = useMapParams();
    const { navigate } = useCustomNavigate();
    const location = useLocation();

    useEffect(() => {
        //to show mobile menu, if we hidden and moving to other tabs
        return () => setShowMobileMenu(true);
    }, []);

    const handleChange = (e: ReactZoomPanPinchRef) => {
        const currentPosition = {
            x: e.state.positionX,
            y: e.state.positionY
        };
        if (position.x !== currentPosition.x || position.y !== currentPosition.y) {
            const scrollDirection = getMovementDirection(position, currentPosition);
            mapState.current = {
                ...mapState.current,
                isPanning: true,
                scrollDirection
            };

            if (scrollDirection === Direction.UP) {
                setShowMobileMenu(false);
            }
            if (scrollDirection === Direction.DOWN) {
                setShowMobileMenu(true);
            }
        }

        setScale(e.state.scale);
        setPosition({
            x: e.state.positionX,
            y: e.state.positionY
        });
    };

    const updateURL = (e: ReactZoomPanPinchRef) => {
        const queryString = toMapQueryString({ pos_x: e.state.positionX, pos_y: e.state.positionY, scale: e.state.scale });
        navigate({ pathname: location.pathname, search: queryString }, { replace: true });
    };

    if ((station && !selectedStation) || (subZone && !expandedStation)) {
        return <LinkNotFound />;
    }

    return (
        <Container>
            <MapContainer>
                <MapHeader />
                <TransformWrapper
                    key={zone.name}
                    initialScale={initialScale || getMapInitialScale(isMapTour)}
                    minScale={MIN_SCALE}
                    maxScale={MAX_SCALE}
                    onTransformed={handleChange}
                    initialPositionX={initialPosition.x}
                    initialPositionY={initialPosition.y}
                    onPanningStop={e => {
                        //expanded station outside click event triggering after panning close, managing panning state to keep expanded station open on panning
                        setTimeout(() => {
                            mapState.current.isPanning = false;
                        }, 200);
                        updateURL(e);
                    }}
                    doubleClick={{
                        disabled: true
                    }}
                    alignmentAnimation={{
                        disabled: true
                    }}
                    panning={{
                        velocityDisabled: true
                    }}
                    onPinchingStop={updateURL}
                    onZoomStop={updateURL}
                    onWheelStop={updateURL}
                    wheel={{
                        smoothStep: 0.001,
                        step: 0.2
                    }}
                    zoomAnimation={{ disabled: true }}
                >
                    <Zone />
                </TransformWrapper>
            </MapContainer>
            {selectedStation ? <Drawer /> : null}
        </Container>
    );
};
